import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Card,
  Form,
  Statistic,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  Button,
  Modal,
  Tooltip,
  List,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import dayjs from "dayjs";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import styles from "../../../../../assets/styles/styles";

const { TextArea } = Input;
const { Content } = Layout;
const { Panel } = Collapse;

const LoanAccChargeForm = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    chargesOptions,
    loanCollateralOptions,
    userData,
    isLoading,
    setIsLoading,
    chargeTableSource,
    setChargeTableSource,
    collateralTableSource,
    setCollateralTableSource,
    penaltyTableSource,
  } = props;
  const { session } = userData;
  // const [useForm] = Form.useForm();
  const { Text, Title } = Typography;

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargeList, setChargeList] = useState([]);
  const [collateralList, setCollateralList] = useState([]);
  // const [isModalOpen, setIsModalOpen] = useState(false);

  const handleChargeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = chargeTableSource.filter((item) => item.id !== key.id);
        setChargeTableSource(newData);
      },

      function () {
        // No button
      },
    );
  };

  const handleCollateralDelete = (key) => {
    console.log(key);
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.type, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = collateralTableSource.filter(
          (item) => item.id !== key.id,
        );
        setCollateralTableSource(newData);
      },

      function () {
        // No button
      },
    );
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Collected On",
      dataIndex: "collectedOn",
    },
    {
      title: "Date",
      dataIndex: "feeOnMonthDay",
    },
    // {
    //   title: "Repayments Every",
    //   dataIndex: "feeInterval",
    // },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        chargeTableSource.length >= 1 ? (
          <Tooltip title={`Remove Charge`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleChargeDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const penaltyColumns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Collected On",
      dataIndex: "collectedOn",
    },
  ];

  const defaultCollateralColumns = [
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Value",
      dataIndex: "value",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        collateralTableSource.length >= 1 ? (
          <Tooltip title={`Remove Collateral`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleCollateralDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const repaymentInfoColumns = [
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Days",
      dataIndex: "days",
    },
    {
      title: "Disbursement",
      dataIndex: "disbursement",
    },
    {
      title: "Principal Due",
      dataIndex: "principalDue",
    },

    {
      title: "Principal Balance",
      dataIndex: "pricipalBalance",
    },

    {
      title: "Interest Due",
      dataIndex: "interestDue",
    },

    {
      title: "Fees",
      dataIndex: "fees",
    },

    {
      title: "Penalty",
      dataIndex: "penalty",
    },

    {
      title: "Dues",
      dataIndex: "dues",
    },
  ];
  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {labelConfig.chargeInfo}
        </Title>
      </Divider>
      <ChargeModal
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        chargeData={chargesOptions}
        setChargeList={setChargeList}
        setChargeTableSource={setChargeTableSource}
        chargeTableSource={chargeTableSource}
        chargeList={chargeList}
        session={session}
      />

      {chargeTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {chargeTableSource.length > 1
                ? labelConfig.selectedCharges
                : labelConfig.selectedCharge}
            </Title>
          </Divider>
          <Table
            columns={columns}
            dataSource={chargeTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}

      {penaltyTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {penaltyTableSource.length > 1
                ? labelConfig.overdueCharges
                : labelConfig.overdueCharge}
            </Title>
          </Divider>
          <Table
            columns={penaltyColumns}
            dataSource={penaltyTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}

      {/* <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {labelConfig.collateralInfo}
        </Title>
      </Divider>
      <CollateralModal
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        collateralData={loanCollateralOptions}
        setCollateralList={setCollateralList}
        collateralTableSource={collateralTableSource}
        setCollateralTableSource={setCollateralTableSource}
        collateralList={collateralList}
        session={session}
      />
      {collateralTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {collateralTableSource.length > 1
                ? labelConfig.selectedCollaterals
                : labelConfig.selectedCollateral}
            </Title>
          </Divider>
          <Table
            columns={defaultCollateralColumns}
            dataSource={collateralTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {labelConfig.repaymentInformation}
        </Title>
      </Divider> */}

      {/* <RepaymentInfoModal
        repaymentInfoColumns={repaymentInfoColumns}
        setIsLoading={setIsLoading}
        session={session}
      /> */}
    </Form>
  );
};
export default LoanAccChargeForm;

const ChargeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setChargeTableSource,
    chargeTableSource,
    chargeData,
  } = props;

  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleChargeSave = (formValues) => {
    const newCharges = {
      key: formValues?.chargeId,
      id: formValues?.chargeId,
      name: formValues.name,
      type: formValues.type,
      collectedOn: formValues.collectedOn,
      amountToUse: formValues?.amount,
      amount: (
        <Statistic
          value={formValues?.amount}
          precision={2}
          valueStyle={{ fontSize: "16px" }}
        />
      ),
      feeOnMonthDay: formValues.feeOnMonthDay
        ? BOM.DateTimeWithoutYear(formValues.feeOnMonthDay, "only-date")
        : "-",
      feeInterval: formValues.feeInterval ? formValues.feeInterval : "-",
    };

    // console.log(chargeTableSource);
    let foundCharge = chargeTableSource.find(
      (item) => item.id === newCharges?.id,
    );
    if (foundCharge) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Charge allowed!");
      return;
    }
    setChargeTableSource([...chargeTableSource, newCharges]);

    useForm.resetFields();
  };

  const handleSelectedCharge = (chargeId) => {
    // console.log(chargeId);
    const params = {
      template: "true",
    };

    const url = `${apiConfig.charges}/${chargeId}`;

    const body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;

        useForm.setFieldsValue({
          key: objList.id,
          id: objList.id,
          name: objList.name,
          type: objList.chargeCalculationType.value,
          collectedOn: objList?.chargeTimeType.value,
          amount: objList?.amount,
          feeOnMonthDay: objList?.feeOnMonthDay
            ? dayjs(BOM.FormatArrayDateWithoutYear(objList?.feeOnMonthDay))
            : objList?.feeOnMonthDay,
          feeInterval: objList?.feeInterval,
        });

        // STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <Row>
      <Button
        shape="round"
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#15CCAE",
          marginBottom: 20,
        }}
      >
        {labelConfig.addCharge}
      </Button>

      <Modal
        title="Charge Information Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleChargeSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"chargeId"}
                label={"Charge Options"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.charge),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase(),
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.charge,
                    "select",
                  )}
                  options={chargeData}
                  onChange={handleSelectedCharge}
                  style={{ width: "30vh" }}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Divider />
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.name} name={"name"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.type} name={"type"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.collectedOn} name={"collectedOn"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.collectedOn,
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.amount} name={"amount"}>
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.date} name={"feeOnMonthDay"}>
                <DatePicker
                  disabledDate={BOM.DisabledAfterCurrentDate}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.date,
                    "select",
                  )}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

// const CollateralModal = (props) => {
//   const {
//     isLoading,
//     setCollateralTableSource,
//     collateralTableSource,
//     collateralData,
//   } = props;

//   const [useForm] = Form.useForm();
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const showModal = () => {
//     setIsModalOpen(true);
//   };
//   const handleOk = () => {
//     setIsModalOpen(false);
//   };
//   const handleCancel = () => {
//     setIsModalOpen(false);
//   };

//   const handleCollateralSave = (formValues) => {
//     console.log(collateralData);
//     const newCollateral = {
//       key: formValues?.collateralId,
//       id: formValues?.collateralId,
//       type: collateralData.find(
//         (item) => item.value === formValues?.collateralId,
//       ).label,

//       value: formValues.collateralValue,
//       description: formValues.description,
//     };

//     let foundCollateral = collateralTableSource.find(
//       (item) => item.id === newCollateral?.id,
//     );
//     if (foundCollateral) {
//       BOM.AlertMsg(cnt.WARNING, "No duplicate Collateral allowed!");
//       return;
//     }
//     setCollateralTableSource([...collateralTableSource, newCollateral]);

//     useForm.resetFields();
//   };

//   return (
//     <Row>
//       <Button
//         shape="round"
//         type="primary"
//         onClick={showModal}
//         // disabled
//         icon={<PlusOutlined />}
//         style={{
//           boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
//           backgroundColor: "#15CCAE",
//           marginBottom: 20,
//         }}
//       >
//         {labelConfig.addLoanCollateral}
//       </Button>

//       <Modal
//         title="Collateral Information Setup"
//         open={isModalOpen}
//         okText="Add"
//         cancelText="Cancel"
//         okButtonProps={{
//           autoFocus: true,
//           htmlType: "submit",
//           style: {
//             ...styles.ofPrimaryBtnColor,
//           },
//         }}
//         centered
//         onCancel={handleCancel}
//         width={800}
//         modalRender={(dom) => (
//           <Form
//             form={useForm}
//             layout="vertical"
//             onFinish={handleCollateralSave}
//             name="address-info"
//           >
//             {dom}
//           </Form>
//         )}
//         style={{
//           height: 600,
//           overflow: "auto",
//         }}
//       >
//         <Spin spinning={isLoading} tip="Loading..." size="large">
//           <Row>
//             <Divider />
//             <Col span={8} style={{ padding: "0px 8px" }}>
//               <Form.Item
//                 name={"collateralId"}
//                 label={"Collateral Options"}
//                 rules={[
//                   {
//                     required: true,
//                     message: BOM.CheckReqFld(labelConfig.collateral),
//                   },
//                 ]}
//               >
//                 <Select
//                   filterOption={(input, option) =>
//                     (option?.label?.toLowerCase() ?? "").includes(
//                       input?.toLowerCase(),
//                     )
//                   }
//                   placeholder={BOM.handlePlaceholderMsg(
//                     labelConfig.collateral,
//                     "select",
//                   )}
//                   options={collateralData}
//                   showSearch
//                 />
//               </Form.Item>
//             </Col>
//             <Col span={8} style={{ padding: "0px 8px" }}>
//               <Form.Item label={labelConfig.value} name="collateralValue">
//                 <Input
//                   placeholder={BOM.handlePlaceholderMsg(labelConfig.value)}
//                 />
//               </Form.Item>
//             </Col>
//             <Col span={8} style={{ padding: "0px 8px" }}>
//               <Form.Item label={labelConfig.description} name="description">
//                 <TextArea
//                   placeholder={BOM.handlePlaceholderMsg(
//                     labelConfig.description,
//                   )}
//                 />
//               </Form.Item>
//             </Col>
//           </Row>
//         </Spin>
//       </Modal>
//     </Row>
//   );
// };

// const RepaymentInfoModal = (props) => {
//   const { repaymentInfoColumns, setIsLoading, session } = props;
//   const [useForm] = Form.useForm();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [repaymentInfoList, setRepaymentInfoList] = useState([]);

//   const getDetail = () => {
//     const params = {
//       command: "calculateLoanSchedule",
//     };

//     const url = `${apiConfig.LoanAccounts}`;

//     let body = {
//       session,
//       params,
//     };

//     setIsLoading(true);

//     BOM.FetchReqAction(body, url, (err, res) => {
//       if (err) {
//         BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
//         setIsLoading(false);
//       } else {
//         const objDetail = res;

//         let tempRepaymentInfoArray = [];

//         objDetail?.periods?.forEach((element) => {
//           tempRepaymentInfoArray.push({
//             key: element?.id,
//             id: element?.id,
//             date: element?.dueDate
//               ? BOM.DateTime(element?.dueDate, "only-date")
//               : "-",
//             days: element?.daysInPeriod ? element?.daysInPeriod : "-",
//             disbursement: element?.principalDisbursed
//               ? element?.principalDisbursed
//               : "-",
//             principalDue: element?.principalDue ? element?.principalDue : "-",
//             pricipalBalance: element?.principalLoanBalanceOutstanding
//               ? element?.principalLoanBalanceOutstanding
//               : "-",
//             interestDue: element?.interestDue ? element?.interestDue : "-",
//             fees: element?.feeChargesDue ? element?.feeChargesDue : "-",
//             penalty: element?.penaltyChargesDue
//               ? element?.penaltyChargesDue
//               : "-",
//             dues: element?.totalDueForPeriod ? element?.totalDueForPeriod : "-",
//           });
//         });

//         setRepaymentInfoList(tempRepaymentInfoArray);
//         setIsLoading(false);
//       }
//     });
//   };

//   const handleClick = () => {
//     setIsModalOpen(true);
//     getDetail();
//   };
//   const handleCancel = () => {
//     setIsModalOpen(false);
//   };

//   return (
//     <Row>
//       <Button
//         type="primary"
//         shape="round"
//         disabled
//         onClick={handleClick}
//         style={{
//           boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
//           backgroundColor: "#15CCAE",
//           marginBottom: 20,
//         }}
//       >
//         {labelConfig.repaymentInfo}
//       </Button>

//       <Modal
//         title="Repayment Information"
//         open={isModalOpen}
//         footer={null}
//         onCancel={handleCancel}
//         width={1000}
//       >
//         <Form form={useForm} layout="vertical" name="address-info">
//           <Divider />

//           <Table
//             columns={repaymentInfoColumns}
//             dataSource={repaymentInfoList}
//           />

//           <Row>
//             <CustomButton
//               content="Cancel"
//               style={{
//                 width: "10%",
//                 marginLeft: "auto",
//                 marginTop: 20,
//                 boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
//               }}
//               backgroundColor="#fff"
//               colorText="black"
//               hoverBackground="#F5F5F5"
//               onClick={() => setIsModalOpen(false)}
//             />
//           </Row>
//         </Form>
//       </Modal>
//     </Row>
//   );
// };
